<template>
    <div style="padding: 20px;width: 100%;height: 100%">
        <div class="titleBox" style="display: flex;align-items: center;">
            <img src="../../../assets/img/icon.png" alt="" style="width: 24px">
            <h3>产品热度</h3>
        </div>
        <div class="wordCloud">
            <div ref="loginTimes" class="block-up-login"></div>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";

export default {
    name: 'productHeat',
    props:['allData'],
    data() {
        return {

        }
    },
    mounted() {
        // 初始化视图
        // this.getIint()
    },
    watch:{
        allData:{
            deep:true,
            immediate:true,
            handler(newVal){
                if(!newVal) return;

                if (newVal) {
                    this.$nextTick(() => {
                        this.allData = newVal;
                        // 初始化视图
                        this.getIint()
                    });
                }

            }
        }
    },
    methods: {
        getIint() {
            // 获取到ref绑定为loginTimes的DOM节点，以canvas的形式展现在视图层
            let myChart = echarts.init(this.$refs.loginTimes)
            // echarts参数设置
            myChart.setOption({
                backgroundColor: 'transparent', // canvas背景颜色
                // canvas标题配置项
                title: {
                    top: '0%',
                    left: '-1%',
                    textStyle: {
                        fontSize: 14,
                        color: '#3B3E41',
                        fontWeight: 'normal'
                    }
                },
                series: [
                    {
                        type: 'wordCloud',
                        left: '5%',                 // X轴偏移量
                        top: '0%',                  // Y轴偏移量
                        width: '100%',               // canvas宽度大小
                        height: '100%',              // canvas高度大小
                        sizeRange: [12, 30],         //  词典字体大小范围配置
                        rotationRange: [0, 0],       // 词典字体旋转角度配置，默认不旋转
                        gridSize: 25,                // 词典字体间距配置
                        layoutAnimation: true,       // 为false词典过度会阻塞
                        textStyle: {                 // 词典样式配置
                            normal: {
                                color:'#98B7E5',
                            }
                        },
                        // 渲染词典数据
                        data: this.allData.pro_list
                    }
                ]
            })
        }
    }
}
</script>

<style scoped lang="scss">
.titleBox{
    img{
        margin-right: 10px;
    }
}
.wordCloud{
    width: 100%;
    height: 80%;
}
.block-up-login{
    height: 100%;
}
</style>